import {ensureHierarchy, mergeToHierarchy} from '#core/utils/config-utils.js';

import {AbstractVisualFeature} from '../../visual-feature.js';
import {Dialogs} from '../dialogs.js';

import QuickStartGuideService from './quick-start-guide-service.js';
import {quickStartGuideDialogConfig} from './quick-start-guide.factory.js';

import SCHEMA from './quick-start-guide.schema.yaml';
import PALETTE_SCHEMA from './quick-start-guide.palette-schema.yaml';

class QuickStartGuideFeature extends AbstractVisualFeature {
    get name() {
        return 'QuickStartGuide';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getVisualConfig(PALETTE) {
        // needed to pass palette to QSG service
        this.palette = PALETTE;

        return quickStartGuideDialogConfig(PALETTE);
    }

    afterMojitoConfigBuild(mojitoConfig) {
        let services = ensureHierarchy(mojitoConfig, 'services');

        services.quickStartGuideService = {service: new QuickStartGuideService(this.config, this.palette)};

        mergeToHierarchy(mojitoConfig, 'services.configurations.HomePage', {
            hideQuickStartGuideBanner: !this.config.showBanner,
        });

        return super.afterMojitoConfigBuild(mojitoConfig);
    }
}

export const QuickStartGuide = new QuickStartGuideFeature(Dialogs);
